import React from 'react';
const stats = [{
  emoji: '📄',
  value: '300+',
  label: 'Páginas'
}, {
  emoji: '🗂',
  value: '6',
  label: 'Tomos operativos'
}, {
  emoji: '💬',
  value: 'Arquitectura',
  label: 'Completa de WhatsApp'
}, {
  emoji: '🧰',
  value: '40+',
  label: 'Guiones, plantillas y checklists'
}];
const coverage = ['Posicionamiento y precios', 'Cierre por WhatsApp', 'Anti-ghosting', 'Recomendación', 'Finanzas', 'Meta Ads'];
export function ProductReveal() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-203" data-mp="2db1j923f8656">
      <div className="mx-auto max-w-5xl px-5 text-center" data-id="element-204" data-mp="28fm1w067fs40">
        <span className="inline-flex items-center gap-2 border border-gold-soft bg-gold-tint px-4 py-2 text-[10px] uppercase tracking-[0.22em] text-ink-soft" data-id="element-205" data-mp="2n2xi4fdc00ag">
          🏆 El manual de operaciones de una agencia de bodas — liberado
        </span>

        <h2 className="mt-8 font-serif text-4xl sm:text-6xl text-ink" data-id="element-206" data-mp="1ulbnabnx9ebo">Wedding Pro OS™</h2>
        <p className="mx-auto mt-5 max-w-3xl font-serif text-xl italic sm:text-2xl text-gold-dark" data-id="element-207" data-mp="1pn09xqyf4lop">
          6 Tomos + 5 Bonos — Del primer &ldquo;Hola, ¿precio para boda?&rdquo; al contrato
          firmado, y de ahí a tres recomendaciones por boda.
        </p>

        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-208" data-mp="1jsr82tmf9u33" />

        <p className="mx-auto mt-8 max-w-3xl text-base sm:text-lg leading-relaxed text-ink-soft" data-id="element-209" data-mp="1oschjxz7xku2">
          Esto no es un curso. No son plantillas de Canva sueltas. Y definitivamente no es
          otra &ldquo;certificación&rdquo; de 9 euros que ninguna novia te va a pedir jamás.
          Es el negocio completo — empaquetado. 300+ páginas de guiones, secuencias,
          protocolos y números que las agencias premium no comparten con nadie.
        </p>

        <p className="mx-auto mt-10 max-w-2xl border-y border-gold-soft py-6 font-serif text-2xl leading-snug sm:text-3xl text-ink" data-id="element-210" data-mp="163fnnv7qgucd">
          No aprendes a ser wedding planner.{' '}
          <span className="italic text-gold-dark" data-id="element-211" data-mp="2hfymb9k6mvii">Instalas el negocio completo.</span>
        </p>

        <ul className="mt-12 grid grid-cols-2 gap-px overflow-hidden border border-gold-soft bg-gold-soft sm:grid-cols-4" data-id="element-212" data-mp="1rrul2b2pcn0t">
          {stats.map(stat => <li key={stat.label} className="bg-ivory px-4 py-7" data-id="element-213" data-mp="21r1syiqo3pgj">
              <div aria-hidden="true" className="text-lg" data-id="element-214" data-mp="21qaam9m2zo87">
                {stat.emoji}
              </div>
              <div className="mt-2 font-serif text-xl text-ink" data-id="element-215" data-mp="1wpw08kx0c270">{stat.value}</div>
              <div className="mt-1 text-[11px] uppercase tracking-[0.14em] text-ink-muted" data-id="element-216" data-mp="192w7tuvpbyg6">
                {stat.label}
              </div>
            </li>)}
        </ul>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-2.5" data-id="element-217" data-mp="1it90ybhl0zxx">
          {coverage.map(item => <li key={item} className="rounded-full border border-ink/10 px-4 py-1.5 text-xs tracking-wide text-ink-soft" data-id="element-218" data-mp="1dzwdi4on2z6r">
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}